import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Eventinquiryhero from "./sections/Eventinquiryhero";
import PlanYourDreamEvent from "./sections/PlanYourDreamEvent";
import ReachOut from "./sections/ReachOut";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Eventinquiryhero />
      <PlanYourDreamEvent />
      <ReachOut />
      <Footer />
    </div>;
}